export default __webpack_public_path__ + "static/media/accounts.4908d79b.svg";